<!--
  ~ Copyright (C) 2025 to Present Applause App Quality, Inc. All rights reserved.
  -->

<div class="option"
     role="option"
     [attr.aria-selected]="selected()"
     [attr.aria-label]="effectiveLabel"
     [id]="optionId"
     [class.hovered]="hovered()"
     [class.selected]="selected()"
     [class.disabled]="disabled">
  <div #content [attr.title]="textLabel">
    <ng-content></ng-content>
  </div>

  <div aria-hidden="true">
    <mat-icon class="selected-icon" [style.visibility]="selected() ? 'visible' : 'hidden'">done</mat-icon>
  </div>
</div>
